import React, { useState } from 'react';
import {IonPopover, IonButton, IonItem, IonList, IonIcon, IonLabel } from '@ionic/react';
import { BASE_URL, Buoy, Signal } from "../utils/constant";
import { chevronDownOutline, informationCircleOutline } from 'ionicons/icons';
import './CustomDropDown.css';

const CustomDropdown = ({ Signal, value, onChange }: { Signal: any[], value: string, onChange: (value: string) => void }) => {
  const [popoverOpen, setPopoverOpen] = useState(false);

  return (
    <>
      {/* Button to trigger popover */}
      <IonButton onClick={() => setPopoverOpen(true)} expand="block" className="chose-signal-btn" fill="outline" >
        {Signal.find((sign) => sign.slug === value)?.name || 'Scegli segnale o boa'}
        <IonIcon icon={chevronDownOutline} slot='end'></IonIcon>
      </IonButton>

      {/* Popover displaying the options */}
      <IonPopover
        isOpen={popoverOpen}
        onDidDismiss={() => setPopoverOpen(false)}
        className="popover-custom"
      >
        <IonList>
          {Signal?.map((sign, index) => (
            <IonItem key={index} button onClick={() => {
                onChange(sign); // Update the selected value
                setPopoverOpen(false); // Close the popover
              }}
            >
              <IonLabel style={{ fontSize: '0.8em' }}>{sign.name}</IonLabel>
              <IonIcon icon={sign.icon} slot="end" className={sign.styleUrl == "#icon-ci-14" || sign.styleUrl == "#icon-ci-15" ? "buoy-dropdown-icon-blink" : ""} />
            </IonItem>
          ))}
        </IonList>
      </IonPopover>
    </>
  );
};

export default CustomDropdown;
